import { useTranslation } from 'react-i18next';
import CeldaSocioPost from './CeldaSocioPost';

export default function TablaSociosPost({ socios }) {

  const { t } =  useTranslation();

  return (
    <div
      className="table-responsive"
      style={{ maxHeight: '450px', overflowY: 'scroll' }}
    >
      <table className="table">
        <thead>
          <tr>
            <th className="col-sm px-sm-2">{t('NAME')}</th>
            <th className="col-sm px-sm-2">{t('TYPE')}</th>
            <th className="col-sm px-sm-2">{t('CABIN_TYPE')}</th>
            <th className="col-sm px-sm-2">{t('MEMBERSHIP')}</th>
            <th className="col-sm px-sm-2">{t('MEMBER_SINCE')}</th>
            <th className="col-sm px-sm-2">{t('TIMES_DELINQUENT')}</th>
            <th className="col-sm px-sm-2">{t('DELINQUENT')}</th>
            <th className="col-sm px-sm-2">{t('MEMBERSHIP')}</th>
          </tr>
        </thead>
        <tbody>
          {socios.map((socio) => (
            <CeldaSocioPost
              key={socio.id}
              socio={socio}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
